import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import Main from "./component/main/Main";

import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'

import { WagmiProvider } from 'wagmi'
import { arbitrum, bsc, mainnet, polygon } from 'wagmi/chains'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import Profile from './pages/profile';
import AuthRazer from './pages/auth-razer';
import FAQ from './pages/faq';
import Delegate from './pages/delegate';
import StakingNFT from './pages/staking-nft';
import HomeDefault from './pages/home-default';
import NodeDetail from './pages/delegate/node-detail';
import BuyNodes from './pages/buy-node';
import Airdrop from './pages/airdrop';
import GetRef from './pages/buy-node/get-ref';

const queryClient = new QueryClient()
const projectId = 'e5d1d3e37f20c213e975e062dbb59bee'
// 2. Create wagmiConfig
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com', // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const helaTestnet: any = {
  id: 666888,
  name: 'HeLa Official Testnet',
  nativeCurrency: { name: 'HLUSD', symbol: 'HLUSD', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://testnet-rpc.helachain.com'] },
  },
  blockExplorers: {
    default: { name: 'HeLascan', url: 'https://testnet-blockexplorer.helachain.com/' },
  },
 testnet: true
}
const helaMainet: any = {
  id: 8668,
  name: 'HeLa Official Runtime Mainnet',
  nativeCurrency: { name: 'HLUSD', symbol: 'HLUSD', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://mainnet-rpc.helachain.com'] },
  },
  blockExplorers: {
    default: { name: 'HeLascan', url: 'https://blockexplorer.helachain.com/' },
  },
 testnet: false
}

const chains = [bsc, mainnet, arbitrum, helaTestnet, helaMainet] as const

const config = defaultWagmiConfig({
  chains, // required
  projectId, // required
  metadata, // required
  enableWalletConnect: true, // Optional - true by default
  enableInjected: true, // Optional - true by default
  enableEIP6963: true, // Optional - true by default
  enableCoinbase: false, // Optional - true by default
  // syncConnectedChain: true, 
  
  
})

// 3. Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  enableAnalytics: true // Optional - defaults to your Cloud configuration
  
})

function App() {
    
    return (
        <div className="App">
          <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
              <Routes>
                  <Route path={`/`} element={<HomeDefault />} />
                  <Route path={`/profile`} element={<Profile />} />
                  <Route path={`/airdrop`} element={<Airdrop />} />
                  <Route path={`/buy-guardian-node`} element={<BuyNodes />} />
                  <Route path={`/get-ref`} element={<GetRef />} />
                  <Route path={`/auth-razer`} element={<AuthRazer />} />
                  <Route path={`/faq`} element={<FAQ />} />
                  <Route path={`/delegate`} element={<Delegate />} />
                  <Route path={`/stake`} element={<StakingNFT />} />
                  <Route path={`/node-detail/:id`} element={<NodeDetail />} />
              </Routes>
            </QueryClientProvider>    
          </WagmiProvider>
        </div>
    );
}

export default App;
